import { Injectable } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { StorageService } from '../../../services/storage.service';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient, MutationOptions, QueryOptions } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';

@Injectable({ providedIn: 'root' })
export class GraphqlProvider {

    private apollo: ApolloClient<any>;

    /**
     * Serviço de integração com a API Graphql
     */
    constructor(settingsService: SettingsService) {
        const authLink = setContext((_, { headers }) => {
            const token = StorageService.getCookie('hub$user$payload');
            return {
                headers: {
                    ...headers,
                    Authorization: token ? `Bearer ${token}` : '',
                },
            };
        });

        this.apollo = new ApolloClient({
            cache: new InMemoryCache(),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'network-only',
                },
                query: {
                    fetchPolicy: 'network-only',
                },
            },
            link: authLink.concat(createHttpLink({
                uri() {
                    const backendUrls = settingsService.getConfigurationKeyValue('backend');
                    return backendUrls && backendUrls.graphqlApi;
                },
            })),
        });
    }

    /**
     * Realiza uma query no endpoint graphql
     *
     * @param  {QueryOptions} options
     */
    public query(options: QueryOptions) {
        return this.apollo.query(options);
    }

    /**
     * Realiza uma mutation no endpoint graphql
     *
     * @param  {MutationOptions} options
     */
    public mutate(options: MutationOptions) {
        return this.apollo.mutate(options);
    }
}
